// extracted by mini-css-extract-plugin
export default {"root":"PlasmicGenerateButton_root__vidL0"};